import { render, staticRenderFns } from "./tt-editor.vue?vue&type=template&id=1c5dea57&"
import script from "./tt-editor.vue?vue&type=script&lang=js&"
export * from "./tt-editor.vue?vue&type=script&lang=js&"
import style0 from "./tt-editor.vue?vue&type=style&index=0&id=1c5dea57&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports